const isGoogleBot = () => {
  if (typeof window === 'undefined') return false;
  return /Googlebot|Googlebot-Image|Google-PageRenderer/.test(
    window.navigator.userAgent,
  );
};

export default isGoogleBot;
